import { apiOrigin } from "./apiClient";

/** GET /auth/session (at the API origin, outside /api) - resolves to the fetch Response. */
export const fetchSession = () => fetch(`${apiOrigin()}/auth/session`, { credentials: "include" });
